import { Check, Zap } from 'lucide-react';
import { StoryStep } from './StoryStep';
import { fmtMoney, fmtPct } from './story-utils';
import type { LandingPageRecommendation } from '@/types/landing-page-analysis';

interface FixesStepProps {
  recommendations: LandingPageRecommendation[];
  revenueLoss: number;
  projectedCvr: number;
  pageCvr: number;
  projectedQualityScore: number;
  qualityScore: number;
}

export function FixesStep({
  recommendations,
  revenueLoss,
  projectedCvr,
  pageCvr,
  projectedQualityScore,
  qualityScore,
}: FixesStepProps) {
  return (
    <StoryStep
      label="Recommended Fixes"
      tag={
        <div className="story-tg story-tg-ok">
          <Zap />
          Quick Wins
        </div>
      }
      collapsedStats={
        <div className="story-acc-stat">
          <span className="label">Recovery</span>
          <span className="story-val-green">+{fmtMoney(revenueLoss)}</span>
        </div>
      }
    >
      <div className="story-fixes">
        {recommendations.map((rec, i) => (
          <div className="story-fx" key={i}>
            <div className="story-fx-marker">
              <Check />
            </div>
            <span className="story-fx-t">{rec.description}</span>
          </div>
        ))}
      </div>

      <div className="story-projs">
        <div className="story-pj">
          <div className="story-pj-lbl">Projected CVR</div>
          <div className="story-pj-val">{fmtPct(projectedCvr)}</div>
          <div className="story-pj-d">up from {fmtPct(pageCvr)}</div>
        </div>
        <div className="story-pj">
          <div className="story-pj-lbl">Revenue Recovery</div>
          <div className="story-pj-val">+{fmtMoney(revenueLoss)}</div>
          <div className="story-pj-d">per month</div>
        </div>
        <div className="story-pj">
          <div className="story-pj-lbl">Quality Score</div>
          <div className="story-pj-val">{projectedQualityScore}/10</div>
          <div className="story-pj-d">up from {Math.round(qualityScore)}/10</div>
        </div>
      </div>
    </StoryStep>
  );
}
